// The profile drawer opens over any page when the URL carries ?profile=1, so the top bar, the
// Settings card and old /profile links all lead to it without leaving the current page.
export const PROFILE_PARAM = "profile";

interface LocationLike {
  pathname: string;
  search: string;
  hash?: string;
}

export const isProfileOpen = (search: string): boolean =>
  new URLSearchParams(search).has(PROFILE_PARAM);

const withSearch = (location: LocationLike, params: URLSearchParams) => {
  const search = params.toString();
  return { pathname: location.pathname, search: search ? `?${search}` : "", hash: location.hash };
};

/** The same page with the profile drawer open (other query parameters are kept). */
export const withProfile = (location: LocationLike) => {
  const params = new URLSearchParams(location.search);
  params.set(PROFILE_PARAM, "1");
  return withSearch(location, params);
};

/** The same page with the profile drawer closed. */
export const withoutProfile = (location: LocationLike) => {
  const params = new URLSearchParams(location.search);
  params.delete(PROFILE_PARAM);
  return withSearch(location, params);
};
